/**
 * 表单字段提交时需要验证的规划方法
 * @description 1.基础字段验证写死 2.图片控件空值校验customRulesImage
 */
import { phonePattern, fixedPhonePattern, emailPattern, phoneNumberPattern } from '@/const/pattern'
const formMixin = {
  data() {
    return {
      rulesPhone: [
        {
          required: true,
          pattern: phonePattern,
          trigger: 'blur',
          message: this.$t('请输入正确的手机号码'),
        },
      ],
      // 2021年1月19日14:52:55,产品提出由于要兼容国外的手机号,改为数字限制20位以内
      rulesPhoneNumber: [
        {
          required: true,
          pattern: phoneNumberPattern,
          trigger: 'blur',
          message: this.$t('最多填写15个数字'),
        },
      ],
      rulesFixedPhone: [
        {
          required: true,
          pattern: fixedPhonePattern,
          trigger: 'blur',
          message: this.$t('请输入正确的固定电话,如：0341-86091234'),
        },
      ],
      rulesEmail: [
        {
          required: true,
          pattern: emailPattern,
          trigger: 'blur',
          message: this.$t('请输入正确的邮箱地址'),
        },
      ],
      rulesPhoneOptional: [
        {
          pattern: phonePattern,
          trigger: 'blur',
          message: this.$t('请输入正确的手机号码'),
        },
      ],
      // 2021年1月19日14:52:55,产品提出由于要兼容国外的手机号,改为数字限制20位以内
      rulesPhoneNumberOptional: [
        {
          pattern: phoneNumberPattern,
          trigger: 'blur',
          message: this.$t('最多填写15个数字'),
        },
      ],
      rulesFixedPhoneOptional: [
        {
          pattern: fixedPhonePattern,
          trigger: 'blur',
          message: this.$t('请输入正确的固定电话,如：0341-86091234'),
        },
      ],
      rulesEmailOptional: [
        {
          pattern: emailPattern,
          trigger: 'blur',
          message: this.$t('请输入正确的邮箱地址'),
        },
      ],
      rulesIndustry: [
        {
          required: true,
          validator: this.industryVerify,
          trigger: 'change',
        },
      ],
      rulesLogo: [
        {
          required: true,
          message: this.$t('请上传企业Logo'),
          validator: this.logo,
          trigger: 'blur',
        },
      ],
      rulesCompanyName: [
        {
          required: true,
          message: this.$t('请输入企业名称'),
          trigger: 'blur',
        },
        {
          max: 120,
          transform: (value) => (value ? value.replace(/[^\x00-\xFF]/g, '01') : ''),
          message: this.$t('最多填写120个字符'),
          trigger: 'blur',
        },
      ],
      rulesDescription: [
        {
          required: true,
          message: this.$t('请输入企业简介'),
          trigger: 'blur',
        },
        {
          max: 5000,
          transform: (value) => (value ? value.replace(/[^\x00-\xFF]/g, '01') : ''),
          message: this.$t('最多填写5000个汉字'),
          trigger: 'blur',
        },
      ],
      rulesWebsite: [
        {
          max: 300,
          transform: (value) => (value ? value.replace(/[^\x00-\xFF]/g, '01') : ''),
          message: this.$t('最多填写300个汉字'),
          trigger: 'blur',
        },
      ],
      rulesContact: [
        {
          required: true,
          message: this.$t('请输入联系人'),
          trigger: 'blur',
        },
        {
          max: 20,
          transform: (value) => (value ? value.replace(/[^\x00-\xFF]/g, '01') : ''),
          message: this.$t('最多填写20个汉字'),
          trigger: 'blur',
        },
      ],
      rulesPost: [
        {
          required: true,
          message: this.$t('请输入岗位'),
          trigger: 'blur',
        },
        {
          max: 30,
          transform: (value) => (value ? value.replace(/[^\x00-\xFF]/g, '01') : ''),
          message: this.$t('最多填写30个汉字'),
          trigger: 'blur',
        },
      ],
    }
  },
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    /**
     * 定制验证级联选择器的校验条件
     * @param {String} message 自定义空值提示文案
     * @param {Array} valueFieldArray
     * @param {*} errorMessage 错误提示
     * @param {Object} rules 覆盖第一条校验规则的设置 默认'{required:true,trigger: 'blur'}'
     */
    customRulesCascader({ message, valueFieldArray, errorMessage, rules }) {
      errorMessage = errorMessage || message
      return [
        {
          required: true,
          message: message || '请选择或输入搜索数据',
          validator: (rule, value, callback) => {
            this.customCascader(rule, value, callback, valueFieldArray, errorMessage)
          },
          trigger: 'change',
          ...rules,
        },
      ]
    },
    /**
     * 级联选择器的自定义校验事件
     * @param {*} rule validator中的校验规则返回
     * @param {*} value v-model绑定的值
     * @param {*} callback 必须调用的函数
     * @param {*} valueFieldArray
     * @param {*} errorMessage
     */
    customCascader(rule, value, callback, valueFieldArray, errorMessage) {
      // console.log('customCascader', rule, value, valueFieldArray, errorMessage)
      for (const item of valueFieldArray) {
        if (item && item.includes('.')) {
          const imageFieldsSplit = item.split('.')
          if (imageFieldsSplit.length === 2) {
            if (!this[imageFieldsSplit[0]][imageFieldsSplit[1]]) {
              return callback(new Error(errorMessage))
            }
          } else if (imageFieldsSplit.length === 3) {
            if (!this[imageFieldsSplit[0]][imageFieldsSplit[1]][imageFieldsSplit[2]]) {
              return callback(new Error(errorMessage))
            }
          }
        } else if (!this[item]) {
          return callback(new Error(errorMessage))
        }
      }
      callback()
    },
    /**
     * 定制字符串输入的校验条件
     * @param {String} message 自定义空值提示文案
     * @param {Object} rules 覆盖第一条校验规则的设置 默认'{required:true,trigger: 'blur'}'
     * @param {Number} max 最大字符数限制
     * @param {String} maxMessage 字符数限制提示文案
     * @param {Array} rulesArray 多条规则验证合并
     */
    customRulesString({ message, rules, max, maxMessage, rulesArray }) {
      const rule = [
        {
          required: true,
          message: message || '请输入值,不能为空',
          trigger: 'blur',
          ...rules,
        },
      ]
      if (max) {
        rule.push({
          min: 1,
          max,
          // transform: (value) =>
          //   value ? value.replace(/[^\x00-\xFF]/g, '01') : '',
          message: maxMessage || `最多填写${max / 2}个汉字（${max}个字符）`,
          trigger: 'blur',
        })
      }
      if (rulesArray && rulesArray.length) {
        console.log('定制字符串输入的校验条件1', [...rule, ...rulesArray])
        return [...rule, ...rulesArray]
      }
      // console.log('定制字符串输入的校验条件2', rule)
      return rule
    },
    /**
     * 定制验证图片控件的上传条件并返回
     * @param {*} valueField 校验值的字段名,可以传两层对象 例如："form.logo" = this.form.logo
     * @param {*} errorMessage 错误提示
     * @param {*} rules 校验规则 默认'{required:true,trigger: 'blur'}'
     */
    customRulesImage(valueField, errorMessage, rules) {
      return [
        {
          required: true,
          message: errorMessage || '请上传图片',
          validator: (rule, value, callback) => {
            this.customImage(rule, value, callback, valueField, errorMessage)
          },
          trigger: 'blur',
          ...rules,
        },
      ]
    },
    /**
     * 图片校验自定义事件
     * @param {*} rule validator中的校验规则返回
     * @param {*} value v-model绑定的值
     * @param {*} callback 必须调用的函数
     * @param {*} valueField
     * @param {*} errorMessage
     */
    customImage(rule, value, callback, valueField, errorMessage) {
      console.log('自定义验证企业logo', rule, value, valueField, errorMessage)
      console.log(valueField, errorMessage)
      let image = ''
      if (valueField && valueField.includes('.')) {
        const imageFieldsSplit = valueField.split('.')
        image = this[imageFieldsSplit[0]][imageFieldsSplit[1]]
      } else {
        image = this[valueField]
      }
      console.log('图片值：', image)
      if (!image) {
        return callback(new Error(errorMessage))
      }
      callback()
    },
  },
}
export { formMixin }
